var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plate-center"},[_c('img',{staticClass:"yh-mt20 yh-mb20",attrs:{"src":require("../assets/1.png"),"alt":""}})])}]

export { render, staticRenderFns }